import { Base64 } from "js-base64";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Layout from "../../../components/layouts/Layout";
import Loader from "../../../components/Loader/Loader";
import { URL_S3 } from "../../../config/BaseUrl";
import useTimeFormate from "../../../hook/useTimeFormat";
import {
  isEnabledValue,
  isEventOptionEnabled,
} from "../packageAccess";
import { EventViewItems } from "./slice/viewEventAction";

const readFirstDefined = (source, keys) => {
  const key = keys.find((item) => source?.[item] !== undefined && source?.[item] !== null);
  return key ? source[key] : null;
};

const unwrapRecord = (value) => Array.isArray(value) ? value[0] || null : value;
const asArray = (value) => Array.isArray(value) ? value : Array.isArray(value?.data) ? value.data : [];

const ViewEvent = () => {
  const { formateLocalTime } = useTimeFormate();
  const history = useHistory();
  useEffect(() => {
    if (history.location.state) {
      toast.warn(history.location.state);
      history.replace();
    }
  }, [history]);

  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(EventViewItems(id));
  }, [dispatch, id]);

  const { event_view, eventViewLoading } = useSelector(
    (state) => state.viewEvent
  );
  const eventSource = event_view || {};
  const incentive_offer = asArray(readFirstDefined(eventSource, ["incentive_offer", "incentive_offers", "offers"]));
  const incentive_details = readFirstDefined(eventSource, ["incentive_details", "incentiveDetails"]);
  const feature = unwrapRecord(readFirstDefined(eventSource, ["feature", "event_feature", "eventFeature", "event_features"]));
  const event_option = unwrapRecord(readFirstDefined(eventSource, ["event_option", "eventOption", "event_options"]));
  const email_setting = unwrapRecord(readFirstDefined(eventSource, ["email_setting", "emailSetting", "email"]));
  const social = unwrapRecord(readFirstDefined(eventSource, ["social", "social_media", "socialMedia"]));
  const text_message = unwrapRecord(readFirstDefined(eventSource, ["text_message", "textMessage", "sms_setting", "smsSetting"]));
  const microsite = unwrapRecord(readFirstDefined(eventSource, ["microsite", "micro_site", "microSite"]));
  const digital_prop = asArray(readFirstDefined(eventSource, ["digital_prop", "digital_props", "digitalProps"]));
  const photo_frame = asArray(readFirstDefined(eventSource, ["photo_frame", "photo_frames", "photoFrames"]));
  const event_video_frame = asArray(readFirstDefined(eventSource, ["event_video_frame", "event_video_frames", "videoFrames"]));
  const event_boomerang_frame = asArray(readFirstDefined(eventSource, ["event_boomerang_frame", "event_boomerang_frames", "boomerangFrames"]));
  const filter = asArray(readFirstDefined(eventSource, ["filter", "filters"]));
  const watermark = unwrapRecord(readFirstDefined(eventSource, ["watermark", "water_mark", "custom_branding", "customBranding"]));
  const gif_gallery = asArray(readFirstDefined(eventSource, ["gif_gallery", "gifGallery"]));
  const brust_gif_gallery = asArray(readFirstDefined(eventSource, ["brust_gif_gallery", "burst_gif_gallery", "burstGifGallery"]));
  const event_form_builder = unwrapRecord(readFirstDefined(eventSource, ["event_form_builder", "eventFormBuilder", "form_builder", "formBuilder"]));

  const checkServiceAvailable = (service) => {
    const eventOptionKey = service === "custom_branding" ? "water_mark" : service;
    return isEventOptionEnabled(event_option, eventOptionKey);
  };

  const checkServiceAvailableForEvent = (service) => {
    return isEventOptionEnabled(event_option, service);
  };

  return (
    <Layout>
      {eventViewLoading ? (
        <Loader />
      ) : (
        event_view && (
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-6">
                  <h5>Event Details</h5>
                </div>
                {/* <div className="text-right col-6">
                                <button type="button" className="btn btn-primary radius-30">Duplicate Event</button>
                            </div> */}
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="bg-transparent shadow-none card">
                    <div className="px-0 card-header">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="capitalize">Event Info</span>
                        <Link
                          to={{
                            pathname: `/event/info/edit/${event_view.id}`,
                            state: { eventInfo: event_view },
                          }}
                        >
                          Edit
                        </Link>
                      </div>
                    </div>
                    <div className="p-0 card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="info-section">
                            <p className="mb-0 font-size-18">Name</p>
                            <p className="mb-0 font-size-12 font-weight-600 ">
                              {event_view.event_name}
                            </p>
                          </div>
                          <div className="info-section">
                            <p className="mb-0 font-size-18">Start Date</p>
                            <p className="mb-0 font-size-12 font-weight-600 ">
                              {formateLocalTime(event_view.event_start_date)}
                            </p>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="info-section">
                            <p className="mb-0 font-size-18">Venue Name</p>
                            <p className="font-size-12 font-weight-600">
                              {event_view.venue_name}
                            </p>
                          </div>
                          <div className="info-section">
                            <p className="mb-0 font-size-18">End Date</p>
                            <p className="font-size-12 font-weight-600">
                              {formateLocalTime(event_view.event_end_date)}
                            </p>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="info-section">
                            <p className="mb-0 font-size-18">
                              Extra Text/Subtitle
                            </p>
                            <p className="font-size-12 font-weight-600">
                              {event_view.event_details}
                            </p>
                          </div>
                          <div className="info-section">
                            <p className="mb-0 font-size-18">TimeZone</p>
                            <p className="font-size-12 font-weight-600">
                              {event_view.time_zone}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <section className="event__option">
                <div className="row">
                  {feature && (
                    <div className="col-md-12">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Event Feature</span>
                            <Link
                              to={{
                                pathname: `/event/feature/edit/${feature.id}`,
                                state: { eventFeature: feature },
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row">
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Still Photo</p>
                                <p className="font-size-12 font-weight-600 ">
                                  {feature &&
                                  feature.still_photo[0].status === true
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">3 In 1</p>
                                <p className="font-size-12 font-weight-600 ">
                                  {feature &&
                                  feature.three_in_one.length > 0 &&
                                  feature.three_in_one[0].status === true
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Video</p>
                                <p className="font-size-12 font-weight-600 ">
                                  {feature && feature.video[0].status === true
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Boomerang</p>
                                <p className="font-size-12 font-weight-600">
                                  {feature &&
                                  feature.boomerang[0].status === true
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Gallery</p>
                                <p className="uppercase font-size-12 font-weight-600">
                                  {feature && feature.gallery[0].status === true
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Sharing</p>
                                <p className="font-size-12 font-weight-600">
                                  {feature && feature.sharing[0].status === true
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Data Capture
                                </p>
                                <p className="font-size-12 font-weight-600">
                                  {feature &&
                                  feature.data_capture[0].status === true
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {event_option && (
                    <div className="col-md-12">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Event Options</span>
                            <Link
                              to={{
                                pathname: `/event/options/edit/${event_option.id}`,
                                state: {
                                  eventOption: event_option,
                                  eventFeature: feature,
                                },
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row">
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Social</p>
                                <p className="font-size-12 font-weight-600 ">
                                  {isEnabledValue(event_option.social_media) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  3 in 1 Animation
                                </p>
                                <p className="font-size-12 font-weight-600 ">
                                  {isEnabledValue(event_option.gif) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Speed Burst</p>
                                <p className="font-size-12 font-weight-600 ">
                                  {isEnabledValue(event_option.brust_gif) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Email</p>
                                <p className="font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.email) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">SMS Sharing</p>
                                <p className="font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.text_messaging) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Props</p>
                                <p className="font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.digital_props) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Custom Branding
                                </p>
                                <p className="font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.water_mark) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Social Gallery
                                </p>
                                <p className="font-size-12 font-weight-600 ">
                                  {isEnabledValue(event_option.microsite) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Selfie Frame</p>
                                <p className="uppercase font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.frame) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Video Frame</p>
                                <p className="uppercase font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.video_frame) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Boomerang Frame</p>
                                <p className="uppercase font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.boomerang_frame) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">QR Code</p>
                                <p className="font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.qr_code)
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Incentives & Offers
                                </p>
                                <p className="font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.incentive_offer) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Filters</p>
                                <p className="font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.filters) ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Form Builder
                                </p>
                                <p className="font-size-12 font-weight-600">
                                  {isEnabledValue(event_option.form_builder)
                                    ? "ON"
                                    : "OFF"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Admin Password
                                </p>
                                <p className="uppercase font-size-12 font-weight-600">
                                  {event_option.admin_password}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {checkServiceAvailable("microsite") && (
                    <div className="col-md-12">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Social Gallery</span>
                            {microsite ? <Link
                              to={{
                                pathname: `/event/microsite/edit/${microsite.id}`,
                                state: { micro_site: microsite },
                              }}
                            >
                              Edit
                            </Link> : null}
                            {/* <Link to="#">Edit</Link> */}
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          {!microsite ? <p className="text-muted">This option is enabled, but its configuration details were not returned.</p> : null}
                          <div className="row">
                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">SMS</p>
                                <p className="font-size-12 font-weight-600 ">
                                  {microsite?.sms ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Email</p>
                                <p className="font-size-12 font-weight-600">
                                  {microsite?.email ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>

                            {/* <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">Facebook</p>
                                                            <p className="font-size-12 font-weight-600">{microsite.facebook ? 'ON' : 'OFF'}</p>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">Twitter</p>
                                                            <p className="font-size-12 font-weight-600">{microsite.twitter ? 'ON' : 'OFF'}</p>
                                                        </div>
                                                    </div> */}
                            {/* <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">Instagram</p>
                                                            <p className="font-size-12 font-weight-600 ">{microsite.instagram ? 'ON' : 'OFF'}</p>
                                                        </div>
                                                    </div> */}

                            {/* <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">LinkedIn</p>
                                                            <p className="font-size-12 font-weight-600 ">{microsite.linked_in ? 'ON' : 'OFF'}</p>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">Snapchat</p>
                                                            <p className="font-size-12 font-weight-600 ">{microsite.snapchat ? 'ON' : 'OFF'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">TikTok</p>
                                                            <p className="font-size-12 font-weight-600 ">{microsite.tiktok ? 'ON' : 'OFF'}</p>
                                                        </div>
                                                    </div> */}
                            {/* <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">Signal</p>
                                                            <p className="font-size-12 font-weight-600 ">{microsite.signal ? 'ON' : 'OFF'}</p>
                                                        </div>
                                                    </div> */}
                            {/* <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">Telegram</p>
                                                            <p className="font-size-12 font-weight-600 ">{microsite.telegram ? 'ON' : 'OFF'}</p>
                                                        </div>
                                                    </div> */}

                            <div className="col-md-6">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Download</p>
                                <p className="font-size-12 font-weight-600 ">
                                  {microsite?.download ? "ON" : "OFF"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="info-section">
                                {microsite?.micro_site_gallery && (
                                  <div className="text-center email-temp">
                                    <div className="mb-2">
                                      <img
                                        className="shadow radius-15"
                                        src={
                                          URL_S3 +
                                          "image/micro_site/" +
                                          microsite.micro_site_gallery
                                            .template_image
                                        }
                                        alt=""
                                        style={{
                                          width: 180,
                                          height: 150,
                                          margin: 16,
                                        }}
                                      />
                                    </div>
                                    {/* <Link
                                                                        to={{ pathname: `${microsite.micro_site_gallery.template_html_code}${Base64.btoa(event_view.id)}` }}
                                                                        target="_blank" className="btn btn-primary">View Gallery</Link> */}

                                    <Link
                                      to={{
                                        pathname: `/social/gallery/${Base64.btoa(
                                          event_view.id
                                        )}`,
                                        state: {
                                          socialGallery:
                                            microsite.micro_site_gallery,
                                        },
                                      }}
                                      className="btn btn-primary"
                                    >
                                      View Gallery
                                    </Link>
                                  </div>
                                )}

                                <div className="text-center email-temp mt-2">
                                  <Link
                                    to={`/social/slide-show/${event_view.id}`}
                                    className="btn btn-secondary"
                                  >
                                    Slideshow
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </section>

              <section className="sharing">
                <h5>Sharing</h5>
                {checkServiceAvailable("email") && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Email</span>
                            {email_setting ? <Link
                              to={{
                                pathname: `/event/email/edit/${email_setting.id}`,
                                state: { emailSetting: email_setting },
                              }}
                            >
                              Edit
                            </Link> : null}
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          {!email_setting ? <p className="text-muted">This option is enabled, but its configuration details were not returned.</p> : null}
                          <div className="row">
                            {/* <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 text-center font-size-18 ">
                                                                <IoDesktop size={80} className="p-2 border rounded bg-ghostwhite" />
                                                            </p>
                                                            <p className="mt-1 text-center font-size-12 font-weight-600 ">Customizable emails not available on your package</p>
                                                        </div>

                                                    </div> */}

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">From Name</p>
                                <p className="font-size-12 font-weight-600">
                                  {email_setting?.from_name || "Not available"}
                                </p>
                              </div>
                              {/* <div className="info-section">
                                                            <p className="mb-0 font-size-18">Attach File</p>
                                                            <p className="uppercase font-size-12 font-weight-600">{email_setting.attach_file ? 'ON' : 'OFF'}</p>
                                                        </div> */}
                            </div>

                            <div className="col-md-3">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Email Subject
                                </p>
                                <p className="font-size-12 font-weight-600">
                                  {email_setting?.email_subject || "Not available"}
                                </p>
                              </div>
                            </div>

                            {/* <div className="col-md-3">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">Email Link</p>
                                                            <p className="font-size-12 font-weight-600">{email_setting.link_image ? 'Web' : ''}</p>
                                                        </div>
                                                    </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row">
                  {checkServiceAvailable("text_messaging") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Text Messaging</span>
                            {text_message ? <Link
                              to={{
                                pathname: `/event/sms/edit/${text_message.id}`,
                                state: { TextMessage: text_message },
                              }}
                            >
                              Edit
                            </Link> : null}
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          {!text_message ? <p className="text-muted">This option is enabled, but its configuration details were not returned.</p> : null}
                          <div className="row ">
                            <div className="col-md-4">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Message</p>
                                <p className="font-size-12 font-weight-600">
                                  {text_message?.text_message || "Not available"}
                                </p>
                              </div>
                            </div>

                            {/* <div className="col-md-4">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Dialing Code
                                </p>
                                <p className="font-size-12 font-weight-600">
                                  {text_message.country}
                                </p>
                              </div>
                            </div> */}

                            <div className="col-md-8">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Automated Clickable Link
                                </p>
                                <p className="font-size-12 font-weight-600">
                                  {text_message?.google_review_link &&
                                  text_message.google_review_link.trim() !== ""
                                    ? text_message.google_review_link
                                    : "Update the automated clickable link by editing the text message."}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Automated Follow Up Message
                                </p>
                                <p className="font-size-12 font-weight-600">
                                  {text_message?.google_review_custom_message &&
                                  text_message.google_review_custom_message.trim() !== ""
                                    ? text_message.google_review_custom_message
                                    : "Update the automated follow up message by editing the text message."}
                                </p>
                              </div>
                            </div>

                            {/* <div className="col-md-4">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">Email Link</p>
                                                            <p className="font-size-12 font-weight-600">{email_setting.send ? 'Web' : ''}</p>
                                                        </div>
                                                    </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {social && checkServiceAvailableForEvent("social_media") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Social</span>
                            <Link
                              to={{
                                pathname: `/event/social/edit/${social.id}`,
                                state: { SocialMedia: social },
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Allow Guest To Share TO FB
                                </p>
                                <p className="font-size-12 font-weight-600">
                                  {social.client_facebook === "1"
                                    ? "YES"
                                    : "NO"}
                                </p>
                              </div>
                            </div>

                            {/* <div className="col-md-6">
                                                        <div className="info-section">
                                                            <p className="mb-0 font-size-18">Enable Instagram GIF Share</p>
                                                            <p className="font-size-12 font-weight-600">{social.instagram === 1 ? 'YES' : 'NO'}</p>
                                                        </div>
                                                    </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="row">
                  {checkServiceAvailableForEvent("digital_props") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Props</span>
                            <Link
                              to={{
                                pathname: `/event/digital-prop/edit/${event_view.id}`,
                                state: { digitalPropsEdit: digital_prop },
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row">
                            <div className="col-md-12 scrollable-item">
                              {digital_prop.map((item, index) => (
                                <div
                                  key={`digital-${index}`}
                                  className="m-2 text-center d-inline-block"
                                  style={{ width: 70, height: 70 }}
                                >
                                  <img
                                    src={`${URL_S3}image/digital_prop/${item.photo_frame}`}
                                    alt=""
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      display: "inline-block",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {checkServiceAvailable("custom_branding") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Custom Branding</span>
                            {watermark ? <Link
                              to={{
                                pathname: `/event/custom-branding/edit/${watermark.id}`,
                                state: { customBranding: watermark },
                              }}
                            >
                              Edit
                            </Link> : null}
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          {!watermark ? <p className="text-muted">This option is enabled, but its configuration details were not returned.</p> : null}
                          <div className="row">
                            <div className="col-md-4">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">X Axis</p>
                                <p className="font-size-12 font-weight-600">
                                  {watermark?.align_x === "50%"
                                    ? "center"
                                    : watermark?.align_x || "Not available"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">Y Axis</p>
                                <p className="font-size-12 font-weight-600">
                                  {watermark?.align_y === "50%"
                                    ? "center"
                                    : watermark?.align_y || "Not available"}
                                </p>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="info-section">
                                <p className="mb-0 font-size-18">
                                  Branding Image
                                </p>
                                <div
                                  className="custom-branding-image"
                                  style={{ height: "30px" }}
                                >
                                  {watermark?.photo ? <img
                                    src={`${URL_S3}image/watermark/${watermark.photo}`}
                                    className="img-fluid h-100"
                                    alt="logo"
                                  /> : <span>Not available</span>}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="row">
                  {checkServiceAvailableForEvent("gif") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">3 in 1 Animation</span>
                            <Link
                              to={{
                                pathname: `/event/gif/edit/${event_view.id}`,
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row ">
                            <div className="mt-2 col-md-12 scrollable-item">
                              {gif_gallery.map((item) => (
                                <div
                                  key={`gif-gallery${item.id}`}
                                  className="m-2 text-center d-inline-block"
                                  style={{ width: 70, height: 70 }}
                                >
                                  <img
                                    src={`${URL_S3}image/gif/preview_image/${item.photo}`}
                                    alt=""
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      display: "inline-block",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {checkServiceAvailableForEvent("brust_gif") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Speed Burst</span>
                            <Link
                              to={{
                                pathname: `/event/brust-gif/edit/${event_view.id}`,
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row ">
                            <div className="mt-2 col-md-12 scrollable-item">
                              {brust_gif_gallery.map((item) => (
                                <div
                                  key={`brust-${item.id}`}
                                  className="m-2 text-center d-inline-block"
                                  style={{ width: 70, height: 70 }}
                                >
                                  <img
                                    src={`${URL_S3}image/burstGif/preview_image/${item.photo}`}
                                    alt=""
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      display: "inline-block",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="row">
                  {checkServiceAvailableForEvent("frame") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Selfie Frame</span>
                            <Link
                              to={{
                                pathname: `/event/frame/edit/${event_view.id}`,
                                state: { eventFrameEdit: photo_frame },
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row ">
                            <div className="mt-2 col-md-12 scrollable-item">
                              {photo_frame.map((item, index) => (
                                <div
                                  key={`photo-frame-${index}`}
                                  className="m-2 text-center d-inline-block"
                                  style={{ width: 70, height: 70 }}
                                >
                                  <img
                                    src={`${URL_S3}image/frame/preview_image/${item.photo_frame}`}
                                    alt=""
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      display: "inline-block",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {checkServiceAvailableForEvent("filters") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Filter</span>
                            <Link
                              to={{
                                pathname: `/event/filter/edit/${event_view.id}`,
                                state: { eventFilterEdit: filter },
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row ">
                            <div className="mt-2 col-md-12 scrollable-item">
                              {filter.map((item, index) => (
                                <div
                                  key={`filter-${index}`}
                                  className="m-2 text-center d-inline-block"
                                  style={{ width: 70, height: 70 }}
                                >
                                  <img
                                    src={`${URL_S3}image/color_filter/${item.filter_photo}`}
                                    alt=""
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      display: "inline-block",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="row">
                  {checkServiceAvailableForEvent("boomerang_frame") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Boomerang Frame</span>
                            <Link
                              to={{
                                pathname: `/event/boomerang-frame/edit/${event_view.id}`,
                                state: { eventFrameEdit: event_boomerang_frame },
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row ">
                            <div className="mt-2 col-md-12 scrollable-item">
                              {event_boomerang_frame.map((item, index) => (
                                <div
                                  key={`photo-frame-${index}`}
                                  className="m-2 text-center d-inline-block"
                                  style={{ width: 70, height: 70 }}
                                >
                                  <img
                                    src={`${URL_S3}image/boomerang_frames/preview_image/${item.photo_frame}`}
                                    alt=""
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      display: "inline-block",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {checkServiceAvailableForEvent("video_frame") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Video Frame</span>
                            <Link
                              to={{
                                pathname: `/event/video-frame/edit/${event_view.id}`,
                                state: { eventFrameEdit: event_video_frame },
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row ">
                            <div className="mt-2 col-md-12 scrollable-item">
                              {event_video_frame.map((item, index) => (
                                <div
                                  key={`photo-frame-${index}`}
                                  className="m-2 text-center d-inline-block"
                                  style={{ width: 70, height: 70 }}
                                >
                                  <img
                                    src={`${URL_S3}image/video_frames/preview_image/${item.photo_frame}`}
                                    alt=""
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      display: "inline-block",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="row">
                  {incentive_offer &&
                    checkServiceAvailable("incentive_offer") && (
                      <div className="col-md-6">
                        <div className="bg-transparent shadow-none card">
                          <div className="px-0 card-header">
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="capitalize">
                                Incentive & offer
                              </span>
                              <Link
                                to={{
                                  pathname: `/event/incentive-offer/edit/${event_view.id}`,
                                  state: {
                                    IncentiveOffer: incentive_offer,
                                    incentiveDetails: incentive_details,
                                  },
                                }}
                              >
                                Edit
                              </Link>
                            </div>
                          </div>
                          <div className="p-0 card-body">
                            <div className="row ">
                              <div className="mt-2 col-md-12 scrollable-item">
                                {incentive_offer.map((item, index) => (
                                  <div
                                    key={`incentive-offer-${index}`}
                                    className="m-2 text-center d-inline-block"
                                    style={{
                                      width: "30%",
                                      minHeight: "70px",
                                      maxHeight: "max-content",
                                      padding: "5px",
                                      background: "#fff",
                                    }}
                                  >
                                    <p>{item.offer_name}</p>
                                    <p>{item.uses_limit}</p>
                                    <p>{formateLocalTime(item.expire_in)}</p>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  {checkServiceAvailable("form_builder") && (
                    <div className="col-md-6">
                      <div className="bg-transparent shadow-none card">
                        <div className="px-0 card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="capitalize">Form Builder</span>
                            <Link
                              to={{
                                pathname: `/event/form-builder/edit/${event_view.id}`,
                                state: {
                                  formData: event_form_builder
                                    ? {
                                        form_data: event_form_builder.form_data,
                                        form_name: event_form_builder.form_name,
                                      }
                                    : null,
                                },
                              }}
                            >
                              Edit
                            </Link>
                          </div>
                        </div>
                        <div className="p-0 card-body">
                          <div className="row ">
                            <div className="mt-2 col-md-12">
                              {event_form_builder ? (
                                <div
                                  className="m-2 text-center d-inline-block"
                                  style={{
                                    width: "250px",
                                    minHeight: "70px",
                                    maxHeight: "max-content",
                                    padding: "5px",
                                    background: "#fff",
                                  }}
                                >
                                  <p>{event_form_builder.form_name}</p>
                                </div>
                              ) : (
                                <div
                                  className="m-2 text-center d-inline-block"
                                  style={{
                                    width: "250px",
                                    minHeight: "70px",
                                    maxHeight: "max-content",
                                    padding: "5px",
                                    background: "#fff",
                                  }}
                                >
                                  <p>No form choosen</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </section>
            </div>
          </div>
        )
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Layout>
  );
};

export default ViewEvent;
